export const hoaDon = {
  sections: {
    list: { title: 'Invoices' },
    detail: { title: 'Invoice detail' },
  },
  lineList: {
    title: 'Invoice line items',
    tabInvoices: 'Invoices',
    tabLines: 'Line items',
    summary: 'Total {count} line items',
    noData: 'No data',
    columns: {
      maHoaDon: 'Invoice code',
      thoiGian: 'Time',
      trangThai: 'Status',
      chiNhanh: 'Branch',
      nguoiBan: 'Seller',
      maKhachHang: 'Customer code',
      tenKhachHang: 'Customer name',
      maHangHoa: 'Product code',
      tenHangHoa: 'Product name',
      donViTinh: 'Unit',
      soLuong: 'Quantity',
      tongCanNang: 'Weight (kg)',
      tongTheTich: 'Volume (m³)',
      donGia: 'Unit price',
      giamGia: 'Line discount',
      giaBan: 'Sale price',
      thanhTien: 'Amount',
      giamGiaChung: 'Order discount',
      thuKhacChung: 'Other charges',
      tongCong: 'Total',
      ghiChu: 'Note',
    },
  },
  titles: { add: 'Add invoice' },
  tabs: {
    banNhanh: 'Quick sale',
    banThuong: 'Standard sale',
    banGiaoHang: 'Delivery sale',
  },
  columns: { code: 'Code', summary: 'Summary', status: 'Status', ngayTao: 'Created at', ngayCapNhat: 'Updated at' },
  filter: { searchPlaceholder: 'Search by invoice code...' },
  filters: {
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    all: 'All',
    fromDate: 'From date',
    toDate: 'To date',
    dateRange: 'Date range',
    dateRangePlaceholder: 'Select date range',
    status: 'Status',
    statusSection: 'Invoice status',
    dateSection: 'Time',
    thoiGianBan: 'Sale time',
    thoiGianTao: 'Created time',
    salesSection: 'Sales',
    peopleSection: 'Users',
    seller: 'Seller',
    deliverySection: 'Delivery',
    deliveryPartner: 'Delivery partner',
    deliveryArea: 'Delivery area',
    deliveryStatus: 'Delivery status',
    otherIncomeType: 'Other income type',
    maHang: 'Item code',
    tenHang: 'Item name',
    textDetailTitle: 'Invoice filters',
    khachHangPlaceholder: 'Search customer',
    loaiBanOnline: 'Online sale type',
    loaiBanOnlineOnline: 'Online order',
    loaiBanOnlineBanGop: 'Multi-branch online',
    sortField: 'Sort by',
    sortDir: 'Order',
    sortThoiGian: 'Sale time',
    sortThoiGianTao: 'Created time',
    sortMaHoaDon: 'Invoice code',
    sortKhachCanTra: 'Amount due',
    sortTongTienHang: 'Merchandise total',
  },
  form: {
    code: 'Invoice code',
    codeAuto: 'Leave blank to auto-generate',
    time: 'Date & time',
    invoiceType: 'Invoice type',
    saleType: 'Sale type',
    typeNoDelivery: 'No delivery',
    typeDelivery: 'Delivery',
    customer: 'Customer',
    customerSearch: 'Search customer (F4)',
    customerQuickAdd: 'Quick add customer',
    customerQuickEdit: 'Edit customer',
    congNoHienTai: 'Outstanding debt',
    congNoKhachNo: 'Customer owes',
    congNoNoKhach: 'We owe customer',
    retailCustomer: 'Walk-in customer',
    bangGia: 'Price list',
    bangGiaDefault: 'Default price',
    pickupAddress: 'Pickup address',
    pickupAddressPlaceholder: 'Select pickup address',
    pickupAddressEmpty: 'No pickup address yet',
    pickupAddressQuickAdd: 'Quick add pickup address',
    channel: 'Sales channel',
    seller: 'Seller',
    saleTime: 'Sale time',
    creator: 'Created by',
    createdAt: 'Created at',
    discount: 'Discount',
    note: 'Note',
    lines: 'Line items',
    danhSachChiTiet: 'Detail list',
    addLine: 'Add line',
    addPriceLine: 'Add price line',
    product: 'Product',
    productName: 'Product name',
    productSearch: 'Search code / name',
    quickSearch: 'Search product (F3)',
    qty: 'Sell qty',
    unitPrice: 'Unit price',
    salePrice: 'Sale price',
    lineTotal: 'Line total',
    editPrice: 'Edit sale price',
    priceBelowCost: 'Warning: unit price is below cost',
    currency: 'VND',
    byAmount: 'By amount',
    byPercent: 'By %',
    unit: 'Conv. unit',
    unitFactor: 'Factor',
    convertedQty: 'Conv. qty',
    lastPrice: {
      label: 'Last price',
      never: 'Customer has never bought this item',
      invoice: 'Invoice',
      qty: 'Quantity',
      unitPrice: 'Unit price',
      discount: 'Discount',
      applyHint: 'Click to apply this price to the line',
      unitMismatch: 'Different unit from the current line — switch unit to apply',
    },
    posTable: {
      stt: '# (No.)',
      action: '+ (Add price line / Delete)',
      groupEdge: 'No. / action columns',
      sellUnit: 'Sale unit',
      sellQty: 'Sale qty',
      sellUnitPrice: 'Sale unit price',
      sellDiscount: 'Sale discount',
      sellPrice: 'Sale price',
      sellTotal: 'Sale amount',
      baseUnit: 'Base unit',
      conversionRate: 'Conversion rate',
      conversionRateHint: '1 sale unit = Rate × base unit',
      baseQty: 'Base qty',
      basePrice: 'Base price',
      baseTotal: 'Base amount',
      groupSell: 'Sale',
      groupBase: 'Base unit conversion',
      columnSettings: 'Column settings',
      resetColumns: 'Reset to default',
      lockedColumn: 'Required column',
    },
    discountPercent: 'Discount (%)',
    lineNote: 'Line note',
    stock: 'Stock',
    comboParts: 'Components',
    comboBadge: 'Combo',
    stockSystemTitle: 'System-wide stock',
    lineAmount: 'Amount',
    delivery: 'Delivery info',
    savedAddress: 'Saved delivery info',
    savedAddressPlaceholder: 'Select delivery info',
    savedAddressEmpty: 'No saved delivery info yet',
    savedAddressQuickAdd: 'Quick add delivery info',
    recipient: 'Recipient',
    phone: 'Recipient phone',
    address: 'Delivery address',
    area: 'Province/City',
    ward: 'Ward',
    areaEmpty: '— Select province/city —',
    wardEmpty: '— Select ward —',
    deliveryPartner: 'Delivery partner',
    serviceType: 'Service type',
    trackingCode: 'Waybill code',
    shippingPanelTitle: 'Shipping',
    deliveryPartnerShort: 'Carrier',
    serviceTypeShort: 'Service',
    trackingCodeShort: 'Waybill',
    appliedFeeShort: 'Fee',
    deliveryStatusShort: 'Status',
    feeNeedAddressHint: 'Pick province/ward',
    weight: 'Weight',
    dimensions: 'Dimensions',
    dimLength: 'Length',
    dimWidth: 'Width',
    dimHeight: 'Height',
    dimUnit: 'Dimension unit',
    measureUnit: 'Unit',
    shippingFee: 'Shipping fee',
    appliedFee: 'Applied fee',
    cod: 'COD',
    deliveryNote: 'Courier note',
    deliveryTime: 'Delivery deadline',
    latestDeliveryTime: 'Delivery deadline',
    deliveryTimeDefault: 'Default',
    deliveryStatus: 'Delivery status',
    payment: 'Payment',
    addPayment: 'Add payment',
    paymentMethod: 'Method',
    amount: 'Amount',
    paymentNote: 'Note',
    otherFee: 'Other fee',
    addOtherFee: 'Add other fee',
    thuKhacSeeMore: 'Show more ({count})',
    thuKhacCollapse: 'Show less',
    category: 'Category',
    value: 'Value',
    percent: 'Percent',
    noCategory: 'No other-fee category available',
    customerInfo: 'Customer info',
    package: 'Package',
    packageCount: 'Packages',
    shippingFeeSection: 'Shipping fee',
    codToggle: 'Collect on delivery (COD)',
    codAmount: 'COD amount',
    shippingViaPartner: 'KiotViet gateway',
    shippingSelf: 'Delivery',
    shippingPartners: 'KiotViet shipping partners',
    shippingGatewayHint:
      'Enter the full address so the system can estimate fees and suggest suitable carriers.',
    discountType: 'Discount type',
    discountValue: 'Discount value',
    orderNote: 'Order note',
    tabLines: 'Item details',
    discountShort: 'Discount',
    vat: 'VAT',
    maHang: 'Item code',
  },
  popup: {
    thuKhac: {
      title: 'Other charges',
      maThuKhac: 'Code',
      loaiThu: 'Charge type / Other fee',
      ghiChu: 'Note',
      ghiChuPlaceholder: 'What is this fee…',
      mucThu: 'Rate',
      thu: 'Amount',
      applyMucThuHint: 'Click to apply catalog rate into Amount',
      hint: 'Rate comes from the catalog. Enter Amount (> 0) to include a charge. Click the rate to fill quickly.',
      total: 'Total',
    },
  },
  fields: {
    maKhachHang: 'Customer code',
    nhanVienPhuTrach: 'Customer sales rep',
    soSanPham: 'Total products',
    soLuongSanPham: 'Total quantity',
    tongCanNang: 'Total weight (kg)',
    tongTheTich: 'Total volume (m³)',
    maHoaDon: 'Invoice code',
    maPhieuTraHang: 'Return code',
    maPhieuXuatKho: 'Stock-out voucher',
    maPhieuNhapKho: 'Stock-in voucher',
    maDatHang: 'Order code',
    maYeuCauSuaChua: 'Repair request code',
    maYeuCauXuatHoaDon: 'Invoice request code',
    nguoiTao: 'Order created by',
    nguoiTaoHeThong: 'System',
    tenKhachHang: 'Customer',
    khachHang: 'Customer',
    kenhBan: 'Sales channel',
    ngayDatHang: 'Order time',
    thoiGianBan: 'Sale time',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    thoiGian: 'Date & time',
    bangGia: 'Price list',
    trangThai: 'Status',
    chiNhanh: 'Branch',
    hinhThucGiao: 'Delivery type',
    diaChiLayHang: 'Pickup address',
    nguoiNhan: 'Recipient',
    dienThoai: 'Phone',
    diaChi: 'Address',
    khuVuc: 'Area',
    phuongXa: 'Ward',
    soKien: 'Packages',
    trongLuong: 'Weight',
    donViTrongLuong: 'Weight unit',
    chieuDai: 'Length',
    chieuRong: 'Width',
    chieuCao: 'Height',
    donViKichThuoc: 'Dimension unit',
    dichVu: 'Delivery service',
    nguoiGiaoDoiTac: 'Deliverer / Partner',
    thuHoTien: 'COD',
    soTienCod: 'COD amount',
    phiTraDTGH: 'Partner fee',
    thoiGianGiaoHang: 'Delivery deadline',
    ghiChuGiaoHang: 'Delivery note',
    ghiChuChoBuuta: 'Courier note',
    tongTienHang: 'Subtotal',
    giamGia: 'Discount',
    thuKhac: 'Other income',
    khachCanTra: 'Amount due',
    khachThanhToan: 'Amount tendered',
    tienThua: 'Change',
    khachDaTra: 'Paid amount',
    tongSauGiamGia: 'Total after discount',
    nguoiBan: 'Salesperson',
    loaiHoaDon: 'Invoice type',
    hinhThucBan: 'Sale type',
    trangThaiGiaoHang: 'Delivery status',
    yeuThich: 'Favorite',
    ghiChu: 'Order note',
    maVanDon: 'Tracking code',
    totalAmount: 'Total amount',
    paidAmount: 'Paid amount',
    payAmount: 'Payment amount',
    paymentMethod: 'Payment method',
    actions: 'Actions',
    chiNhanhXuLy: 'Handling branch',
    chiNhanhTao: 'Created at branch',
    nguoiNhanDat: 'Seller',
    kichThuoc: 'Dimensions',
    thuHoTienShort: 'COD',
    giamGiaHoaDon: 'Invoice discount',
    phiShip: 'Shipping fee',
  },
  paymentMethod: {
    TIEN_MAT: 'Cash',
    THE: 'Card',
    VI: 'Wallet',
    CHUYEN_KHOAN: 'Bank transfer',
  },
  status: {
    DANG_XU_LY: 'Processing',
    HOAN_THANH: 'Completed',
    KHONG_GIAO_DUOC: 'Undeliverable',
    DA_HUY: 'Cancelled',
    DA_HUY_DO_CHINH_SUA: 'Cancelled (edited)',
  },
  deliveryStatus: {
    CHO_XU_LY: 'Pending',
    CHO_LAY_HANG: 'Awaiting pickup',
    DANG_GIAO: 'Delivering',
    DA_GIAO: 'Delivered',
    GIAO_THAT_BAI: 'Failed delivery',
    PHAT_KHONG_THANH_CONG: 'Delivery failed',
    DANG_TRA_HANG: 'Returning',
    TRA_HANG: 'Returned',
    HUY: 'Cancelled',
  },
  messages: {
    loadError: 'Could not load invoices.',
    deleteSuccess: 'Invoice deleted.',
    createSuccess: 'Invoice created.',
    updateSuccess: 'Invoice updated.',
    capNhatConfirm: {
      title: 'Update invoice',
      intro: 'When you change information on the invoice, the system will:',
      item1: 'Cancel the old invoice and create a new one',
      item1VanHanh:
        'If items / quantities change: cancel the old invoice, create a new one and the warehouse restarts. If only info changes: the invoice code is kept',
      khoDangXuLy: 'This order is being processed by the warehouse',
      khoChanSuaHang:
        'Picking has started — you cannot add/remove products or change quantities. Price, discount, customer, delivery and notes can still be edited.',
      khoSuaThongTin:
        '• Info-only changes (price, discount, customer, delivery, note...): the invoice keeps its code, the warehouse is notified and continues.',
      khoDoiHang:
        '• Changing items or quantities is blocked — ask the warehouse to cancel processing (reset to before Picking) first; then the edit creates a new invoice for the warehouse to redo.',
      item1KhongSinhDuoi:
        'Info-only changes that do not affect stock (price, discount, customer, delivery…): keep the invoice code, no suffix version is created',
      item2: 'All payment slips of the old invoice will be assigned to the new invoice',
      item3: 'If you change the quantity of goods, ensure the store stock is sufficient — the system will not re-check.',
      question: 'Do you want to continue?',
      dongY: 'Agree',
      boQua: 'Skip',
    },
    needLines: 'Please add at least one line item.',
    needKhachHang: 'Please select a customer.',
    validateThoiGianGiaoBeforeThoiGian:
      'Delivery time must not be before the order/invoice time.',
    deliveryTimeBeforeNow: 'A new delivery deadline cannot be before the current time.',
    thoiGianGiaoDichLocked: 'Changing the transaction time is not allowed by system settings.',
    thoiGianGiaoDichOutOfRange: 'Transaction time is outside the allowed date range.',
    invalidDienThoaiNguoiNhan: 'Recipient phone number is invalid (8–15 digits).',
    invalidTrongLuong: 'Weight must be a non-negative number.',
    invalidKichThuoc: 'Dimensions (length/width/height) must be non-negative numbers.',
    warnStockCost: 'Stock/cost warning: {detail}',
    noData: 'No invoices.',
    noLines: 'No line items.',
    listSummary: 'Total {count} invoices',
    confirmDelete: 'Delete invoice {name}?',
    favoriteSuccess: 'Favorite updated.',
    saoChepSuccess: 'Invoice copied.',
    statusSuccess: 'Invoice status updated.',
    confirmKetThuc: 'Complete invoice {name}? Status will be updated to Completed.',
    confirmHuy: 'Cancel invoice {name}? Status will be updated to Cancelled.',
    confirmHuySelected:
      'Cancel {count} selected invoices? Status will be updated to Cancelled. Already cancelled / completed / locked invoices will be skipped.',
    confirmHuyDaThu:
      'The customer has already paid {soTien} on invoice {name}. Cancelling will not refund it automatically and the amount will no longer count toward the receivable — refund the customer or record it manually. Cancel anyway?',
    huySelectedSuccess: 'Cancelled {ok}/{total} invoices.',
    huySelectedPartial: 'Cancelled {ok}/{total} invoices. {fail} failed or could not be cancelled.',
    huySelectedNone: 'None of the selected invoices can be cancelled.',
    paySuccess: 'Payment recorded.',
    invalidPayAmount: 'Invalid payment amount.',
    importSuccess: 'Import successful.',
    importDescription:
      'Download the template (no invoice code / channel). Empty time = now, seller = you. Contiguous same-customer rows merge; interrupted same customer splits.',
    importWillCreate: 'Will create {count} invoice(s) from the selected file.',
    importPreviewProgress: 'Preview {current}/{total}',
    importPreviewStopped: 'Preview stopped.',
    importPreviewDone: 'Preview finished {done}/{total} invoice(s).',
    importPreviewLoading: 'Preparing invoice {current}/{total}…',
    phieuXuatKhoFromInvoice: 'Sales out from invoice {code}',
    traHangNeedPhieuXuatKho: 'Create a goods issue before returning.',
    traHangDaTraHet: 'Fully returned — cannot return more.',
  },
  aria: {
    columnPicker: 'Choose visible columns',
    toggleStar: 'Toggle favorite',
    selectAllPage: 'Select all rows on this page',
    selectRow: 'Select row',
  },
  detailTabs: {
    chung: 'General',
    generalInfo: 'Information',
    chiTietDonHang: 'Order details',
    khoFlow: 'Warehouse flow',
  },
  khoFlow: {
    trangThai: 'Fulfillment status',
    chuaToi: 'Not reached yet',
    empty: 'This invoice has not entered the warehouse flow yet.',
  },
  actions: {
    pay: 'Pay',
    favorite: 'Favorite',
    changeStatus: 'Change status',
    print: 'Print',
    printHoaDon: 'Print invoice',
    exportExcelHoaDon: 'Export Excel',
    printNhiet: 'Print delivery slip',
    exportFile: 'Export file',
    dieuChinhCot: 'Adjust columns',
    traHang: 'Return goods',
    taoPhieuXuatKho: 'Create stock-out voucher',
    phieuXuatKho: 'Stock-out',
    saoChep: 'Copy',
    taoYeuCau: 'Create VAT export request',
    taoYeuCauSelected: 'Create invoice request ({count})',
    taoYeuCauMenu: 'Create invoice request',
    printSelected: 'Print ({count})',
    printMenu: 'Print',
    huySelected: 'Cancel ({count})',
    huyMenu: 'Cancel',
    bulkSelected: 'Actions ({count})',
    ketThuc: 'Complete',
    taoDatHang: 'Create order',
    capNhat: 'Update',
    dongY: 'Agree',
    xuLyDonHang: 'Process order',
    huyBo: 'Cancel',
    copy: 'Copy',
  },
  placeholders: {
    formTitle: 'Create / edit invoice',
    formBody: 'Full form will be added. Excel import via API when needed.',
    ghiChu: 'Note...',
    ghiChuGiao: 'Delivery note...',
    chonDoiTac: 'Select partner...',
  },
  pos: {
    tabNew: 'New invoice',
    newTabHoaDon: 'New invoice',
    newTabTraHang: 'New return',
    tabEdit: 'Edit {code}',
    tabClone: 'Clone of {code}',
    tabTitle: 'Invoice {n}',
    switchToDatHang: 'Switch to order',
    switchToHoaDon: 'Switch to invoice',
    tabFromDatHang: 'New invoice · from {code}',
    tabFromYeuCauSuaChua: 'New invoice · from {code}',
    addTab: 'Add invoice',
    history: 'Invoice history',
    confirmCloseTitle: 'Close this tab?',
    confirmCloseBody: 'Tab has unsaved changes. Closing will lose them.',
    openEdit: 'Open edit tab',
    openClone: 'Clone',
    saved: 'Invoice saved.',
  },
  summary: {
    tongTienHangCount: 'Subtotal ({count})',
    tongSoLuong: 'Total quantity',
    tongTienHang: 'Subtotal',
    giamGiaPhieuDat: 'Discount',
    tongCong: 'Total',
    hangSuaChua: 'Repair items',
    maHangDeLai: 'Left-behind item codes',
    capSuaChua: 'Pair {stt}',
  },
}
